import React from "react";
import ShimmerVideoFeed from "./ShimmerVideoFeed";
import SkeletonVideoFeedElement from "./SkeletonVideoFeedElement";

const SkeletonVideoFeed = ({ theme }) => {
  const themeClass = theme || "dark";

  return (
    <div className={`skeleton-wrapperV ${themeClass}`}>
      <div className="skeleton-articleV">
        <div className="skeleton-profileV row">
          <div className="col-1">
            <SkeletonVideoFeedElement type="avatar" />
          </div>

          <div className="col-11">
            <SkeletonVideoFeedElement type="title" />
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column justify-content-end p-2">
            <SkeletonVideoFeedElement type="avatar" />
            <SkeletonVideoFeedElement type="avatar" />
            <SkeletonVideoFeedElement type="avatar" />
            <SkeletonVideoFeedElement type="avatar" />
          </div>
          <SkeletonVideoFeedElement type="thumbnail" />
          <div className="d-flex flex-column justify-content-end p-2">
            <SkeletonVideoFeedElement type="avatar" />
            <SkeletonVideoFeedElement type="avatar" />
           
          </div>
        </div>

 
      </div>
      <ShimmerVideoFeed />
    </div>
  );
};

export default SkeletonVideoFeed;
